import { RedirectionStateObject } from '../types';
import { tanstackUrlSearch, uriSafe } from '../utils';

export const unifiedDashboardsRedirections: RedirectionStateObject = {
  'dashboard.dashboards-hub': () => `/360/dashboards/dashboards-hub`,
  'dashboard.dashboards-hub-legacy': () => `/360/dashboards/dashboards-hub`,
  'dashboard.view-dashboard': params => {
    const { folderId, dashboardId, ...rest } = params;
    const search = tanstackUrlSearch(rest);
    const base = `dashboards/dashboards-hub/view/folders/${uriSafe(folderId)}/dashboards/${uriSafe(dashboardId)}`;

    return `/360/${base}${search}`;
  },
};
